import { NextSeo } from 'next-seo';
import OnboardingLayout from '@c/layouts/OnboardingLayout';
import LoginOrSignupPage from '@c/LoginOrSignupPage';

const Login = () => {
  return (
    <>
      <NextSeo
        title="Login - GearFocus"
        noindex={true}
        nofollow={true}
      />
      <LoginOrSignupPage />
    </>
  );
};

Login.getLayout = function getLayout(page: React.ReactElement) {
  return <OnboardingLayout>{page}</OnboardingLayout>;
};

export default Login;
